// src/pages/AdminHome.js
import React from "react";
import PendingRequests from "../components/PendingRequests";
import AdminConsole from "./AdminConsole";

/**
 * Admin landing page.
 * This is intentionally NOT an "employee view" clone.
 * - Approvals: pending time-off requests
 * - User management: roles, allotments, password reset, etc.
 */
export default function AdminHome() {
  return (
    <div className="space-y-6">
      <PendingRequests />
      <AdminConsole />
    </div>
  );
}
